export const columnsNames = {
  id: {
    name: "ID",
    value: "id",
  },
  status: {
    name: "Status",
    value: "status",
  },
  row_number: {
    name: "S.no",
    value: "row_number",
  },
  room: {
    name: "Room",
    value: "room_name.name",
  },
  observation: {
    name: "Observation",
    value: "observation.name",
  },
  sample_type: {
    name: "Sample Type",
    value: "test",
  },
  sample_location: {
    name: "Sample Location",
    value: "sample_info[0].value",
  },
  sample_note: {
    name: "Notes",
    value: "sample_note",
  },
  result: {
    name: "Results",
    value: "result",
  },
  tier: {
    name: "Tier",
    value: "tier",
  },
  client_approval: {
    name: "Status",
    value: "client_approved",
  },
};

export const hvacColumnsNames = {
  id: {
    name: "ID",
    value: "id",
  },
  room: {
    name: "HVAC System",
    value: "room_name.name",
  },
  sample_note: {
    name: "Notes",
    value: "sample_note",
  },
  result: {
    name: "Results",
    value: "result",
  },
  status: {
    name: "Status",
    value: "status",
  },
  tier: {
    name: "Tier",
    value: "tier",
  },
  client_approval: {
    name: "Status",
    value: "client_approved",
  },
};

export const ambientColumnsNames = {
  id: {
    name: "ID",
    value: "id",
  },
  room: {
    name: "Ambient Living Area",
    value: "room_name.name",
  },
  sample_note: {
    name: "Notes",
    value: "sample_note",
  },
  result: {
    name: "Results",
    value: "result",
  },
  status: {
    name: "Status",
    value: "status",
  },
  tier: {
    name: "Tier",
    value: "tier",
  },
  client_approval: {
    name: "Status",
    value: "client_approved",
  },
};

export const sampleInfoKeys = {
  SAMPLE_LOCATION: {
    id: "",
    name: "Sample Location",
    value: "",
  },
};

export const financedData = [
  { name: "Down Payment", cost: 100.0 },
  { name: "Amount Financed", cost: 9960.0 },
];
export const sampleData = [
  { name: "Air", count: 145.0 },
  { name: "Swab", count: 145.0 },
  { name: "Bulk", count: 145.0 },
  { name: "ERMI/MSQPCR", count: 595.0 },
  { name: "EPA 36", count: 595.0 },
  { name: "FAB 3", count: 595.0 },
];
export const costData = [
  { name: "Mycotoxin", count: 700.0 },
  { name: "Endotoxin", count: 595.0 },
  { name: "Actinomycetes", count: 595.0 },
  { name: "Sewage Bacteria", count: 595.0 },
  { name: "VOC", count: 595.0 },
  { name: "Formaldehyde", count: 595.0 },
];
